// ProviderDropdown.js
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { getHeaders } from '../../../lib/requests';

function ProviderDropdown({ onSelect, selectedProviderId }) {
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const apiToken = localStorage.getItem('accessToken');
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${apiUrl}/clients`, {
          headers: getHeaders(apiToken),
        });
        setProviders(response.data.data);
      } catch (error) {
        console.error('Error fetching providers', error);
      }
    };

    fetchProviders();
  }, []);

  useEffect(() => {
    if (selectedProviderId && providers.length > 0) {
      const provider = providers.find(p => p.client_id === selectedProviderId);
      setSelectedProvider(provider || null);
    }
  }, [selectedProviderId, providers]);

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const handleSelectProvider = (provider) => {
    setSelectedProvider(provider);
    setShowDropdown(false);
    onSelect(provider);
  };

  const handleClearSelection = (e) => {
    e.stopPropagation();
    setSelectedProvider(null);
    onSelect(null);
  };

  return (
    <div className="relative inline-block text-left w-full">
      <button
        id="providerDropdownButton"
        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 w-full justify-between"
        type="button"
        onClick={toggleDropdown}
      >
        <span>{selectedProvider ? selectedProvider.name : 'Select Provider'}</span>
        <div className="flex items-center gap-2">
          {selectedProvider && (
            <span
              className="text-white hover:text-gray-200"
              onClick={handleClearSelection}
            >
              ×
            </span>
          )}
          <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 8l5 5 5-5" />
          </svg>
        </div>
      </button>

      {showDropdown && (
        <div className="absolute z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-full dark:bg-gray-700 mt-1">
          <ul className="py-2 text-sm text-gray-700 dark:text-gray-200 max-h-60 overflow-y-auto" aria-labelledby="providerDropdownButton">
            {providers.map(provider => (
              <li key={provider.client_id}>
                <a
                  href="#"
                  className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSelectProvider(provider);
                  }}
                >
                  {provider.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

ProviderDropdown.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selectedProviderId: PropTypes.string,
};

export default ProviderDropdown;
